export default {
  custom: {
    'customer.full-name': 'Name',
    'customer.mobile': 'Mobile',
    'customer.email': 'Email',
    'customer.unique-code': 'Person Unique ID',
    'team.name': 'Team',
    'team.unique-code': 'Team Unique ID',
    'team.section': 'Competition',
    'team.season': 'Season',
  },
  sportsTg: {
    'customer.full-name': 'Name',
    'customer.mobile': 'Mobile',
    'customer.email': 'Email',
    'customer.unique-code': 'Person Unique ID',
    'team.name': 'Team',
    'team.unique-code': 'Team Unique ID',
    'team.section': 'Competition',
    'team.season': 'Season',
  },
  playHq: {
    'customer.full-name': 'Name',
    'customer.mobile': 'Mobile',
    'customer.email': 'Email',
    'customer.unique-code': 'Person Unique ID',
    'team.name': 'Team',
    'team.unique-code': 'Team Unique ID',
    'team.section': 'Competition',
    'team.season': 'Season',
  },
  fixi: {
    'customer.full-name': 'Name',
    'customer.mobile': 'Mobile',
    'customer.email': 'Email',
    'customer.unique-code': 'Person Unique ID',
    'team.name': 'Team',
    'team.unique-code': 'Team Unique ID',
    'team.section': 'Competition',
    'team.season': 'Season',
  },
  teammo: {
    'customer.full-name': 'Name',
    'customer.mobile': 'Mobile',
    'customer.email': 'Email',
    'customer.unique-code': 'Person Unique ID',
    'team.name': 'Team',
    'team.unique-code': 'Team Unique ID',
    'team.section': 'Competition',
    'team.season': 'Season',
  },
};
